import React from 'react';

export default function Attending(props) {
    let attend1 = 'The Workshop on Privacy Threat Modeling will be held in conjunction with the ';
    let attend2 = ', August 10-12 in Seattle, WA. ';
    let attend3 = 'The workshop will take place ';
    let attend4 = 'in person and online on Sunday, August 10th from 2PM-6PM PDT.';
    let attend5 = 'There is no cost for virtual attendence.';
    let attend6 = " To attend in person, you must register for both SOUPS and the workshop to attend. The workshop registration fee is US $75.";

    // let attend7 = 'Attendees may submit a 1-page presentation proposal to be considered for a formal speaking role. Please see ';
    // let attend8 = ' for details.';
    // let attend9 = 'We are pleased to announce that we have modified the workshop format to accommodate more participants and have re-opened registration.';
    let reg_open = 'Workshop registration is open';
    // let reg_note = 'UPDATE: ' /*'Please note that for logistical reasons registration will be capped at 60 attendees.'*/;
    // let reg_close = 'UPDATE: With apologies for any disappointment, due to overwhelming response, we have suspended workshop registration and are not currently accepting additional attendees.';
    // let reg_note2 = 'We are pleased to announce that we have modified the workshop format to accomodate more participants and have re-opened registration.';

    return (
        <div className='base-page'>
            <div className='attending-details'>
                <h4 className='heading'>Attending</h4>
                <p><b>{reg_open}</b></p>
                <hr style={{marginTop:'25px', marginBottom:'25px'}}></hr>

                <p>{attend1} 
                <a className='link' href='https://www.usenix.org/conference/soups2025#registration' target='_blank' rel="noopener noreferrer">Symposium on Usable Privacy and Security (SOUPS) 2025</a>
                {attend2}
                </p>

                <p>{attend3}&nbsp;{attend4}</p>
                <div>
                    <p>{attend5} 
                    <b>{attend6}</b></p>
                </div>
           

                {/* Registration button */}
                <ul style={{paddingLeft:'0px'}}>
                    <li style={{display:'inline-block'}}>
                        <button className='submit' onClick={()=> window.open("https://forms.office.com/pages/responsepage.aspx?id=SNwgxlAdUkmLOd9NVNdNglcltiAMc_pLiOxb7DdtWLRUOERYU09UTDc0NFkyT1hDVTRZVjhBSTlLUy4u&route=shorturl", "_blank", "noopener, noreferrer")}>
                            Register for Virtual Attendance
                        </button>
                    </li>
                </ul>

                <p>Please send any questions to PTMworkshop@mitre.org</p>
                
            </div>
        </div>
    )
}
